import { render, staticRenderFns } from "./modalAlterarSenha.vue?vue&type=template&id=b965f610&"
import script from "./modalAlterarSenha.vue?vue&type=script&lang=js&"
export * from "./modalAlterarSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports